import EmployeePerformanceAssessmentResultsComponents from "../components/EmployeePerformanceAssessmentResults";
import useEmployeePerformanceAssessmentResults from "../hooks/useEmployeePerformanceAssessmentResults";

function EmployeePerformanceAssessmentResults() {
  const employeePerformanceAssessmentResultsProps =
    useEmployeePerformanceAssessmentResults();
  return (
    <EmployeePerformanceAssessmentResultsComponents
      {...employeePerformanceAssessmentResultsProps}
    />
  );
}

export default EmployeePerformanceAssessmentResults;
